<!--<app-developer-artifact-assembly-picker></app-developer-artifact-assembly-picker>-->
<app-developer-artifact-xml-picker [xmlTypes]="datafield.AdditionalInfo" [selectedArtifactId]="datafield.Value" (selectedArtifactIdChange)="setValue($event)"></app-developer-artifact-xml-picker>
@if (!isValid) {
  <div class="error">This field is required</div>
}
